import { render, staticRenderFns } from "./DuplicateLogsDetails.vue?vue&type=template&id=32b12d64&"
import script from "./DuplicateLogsDetails.vue?vue&type=script&lang=js&"
export * from "./DuplicateLogsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports